export const urls = {
  VRATI_STAVKE:
    'DokNarudzbineStavke/narudzbine_vrati_delove_iz_narudzbine_za_masinu',
};
